import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PopupRef from '../../../component/PopupRef';
import { modalType } from '../../../util/ModalUtil';
import CheckBox from '../../../component/CheckBox';
import CancelButtonBox from '../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../component/buttons/ConfirmButtonBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';

const JoinUsPhase1View = ({ setPhase, type, modalRef, invisibleCheckbox }) => {
    const navigate = useNavigate();

    const [agreeAll, setAgreeAll] = useState(false);
    const [agree1, setAgree1] = useState(false);
    const [agree2, setAgree2] = useState(false);

    const popupRef = useRef(null);

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (agree1 && agree2) {
            setAgreeAll(true);
        } else {
            setAgreeAll(false);
        }
    });

    const handleAgreeAll = (agree) => {
        setAgree1(agree);
        setAgree2(agree);
        setAgreeAll(agree);
    };

    const handleConfirm = () => {
        if (type == modalType.DETAIL) modalRef.current.close();

        if (agreeAll) {
            SessionStorageUtil.setAgreeAll(true);
            setPhase(2);
        } else {
            popupRef.current.openAlert('동의하지 않은 항목이 있습니다.');
        }
    };

    return (
        <>
            <div className='join-content'>
                <h3 className='sub-tit'>개인정보 수집·이용·3자 제공 동의</h3>
                <div className='personal-info-box'>
                    <p className='p-info-comment'>
                        개인정보보호법 제15조 1항(개인정보의 수집·이용) 및 제 17조(개인정보의 제공)에 의거하여
                        혁신융합대학사업(미래자동차) 수강신청을 목적으로 개인정보를 수집‧이용 및 제3자 제공하고자
                        합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
                    </p>

                    {!invisibleCheckbox && (
                        <div className='check-all-box'>
                            <CheckBox
                                id='checkbox-1'
                                checked={agreeAll}
                                onChecked={handleAgreeAll}
                                span='개인정보 수집‧이용, 개인정보 3자 제공에 모두 동의합니다.'
                            />
                        </div>
                    )}

                    <div className={'check-detail-box ' + (invisibleCheckbox ? 'mt40' : '')}>
                        <CheckBox
                            id='checkbox-2'
                            checked={invisibleCheckbox ? true : agree1}
                            disable={invisibleCheckbox ? true : false}
                            onChecked={setAgree1}
                            span='개인정보 수집‧이용 동의'
                        />
                        <div className='p-info-table con-tb-box table-common'>
                            <table>
                                <caption className='blind'>개인정보 수집‧이용 항목 정보</caption>
                                <colgroup>
                                    <col style={{ width: '33.3333%' }} />
                                    <col style={{ width: '33.3333%' }} />
                                    <col style={{ width: '33.3333%' }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope='col'>수집‧이용 항목</th>
                                        <th scope='col'>수집‧이용 항목</th>
                                        <th scope='col'>보유기간</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>성명, 전공(학과), 학번, 연락처(휴대전화 E-mail)</td>
                                        <td>혁신융합대학사업(미래자동차) 수강신청</td>
                                        <td>5년</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p className='caution-comment'>
                            ※ 위의 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우
                            “혁신융합대학사업(미래자동차) 수강신청지원시스템” 사용이 제한될 수 있습니다.
                        </p>
                    </div>
                    <div className='check-detail-box mt40'>
                        <CheckBox
                            checked={invisibleCheckbox ? true : agree2}
                            disable={invisibleCheckbox ? true : false}
                            onChecked={setAgree2}
                            span='개인정보 3자 제공 동의'
                        />
                        <div className='p-info-table con-tb-box table-common'>
                            <table>
                                <caption className='blind'>개인정보 수집‧이용 항목 정보</caption>
                                <colgroup>
                                    <col style={{ width: '25%' }} />
                                    <col style={{ width: '25%' }} />
                                    <col style={{ width: '25%' }} />
                                    <col style={{ width: '25%' }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope='col'>제공받는 자</th>
                                        <th scope='col'>수집‧이용 항목</th>
                                        <th scope='col'>제공 항목</th>
                                        <th scope='col'>보유기간</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>혁신융합대학사업(미래자동차) 참여 대학</td>
                                        <td>혁신융합대학사업(미래자동차) 수강신청</td>
                                        <td>성명, 전공(학과), 학번, 연락처(휴대전화 E-mail)</td>
                                        <td>처리목적 달성시까지</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p className='caution-comment'>
                            ※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우
                            “혁신융합대학사업(미래자동차) 수강신청지원시스템” 사용이 제한될 수 있습니다.
                        </p>
                    </div>
                </div>
                {!invisibleCheckbox && (
                    <div className='join-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                )}
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default JoinUsPhase1View;
